<div class="huddle-meetings-top-panel">
  <div class="huddle-meetings-control-panel">
    <div class="huddle-meetings-left-control">
      <p class="tab-description">
        Access all Huddles across Spotlights, Action Plans, and Suggestions with detailed drill-downs.
      </p>
    </div>
    <div class="huddle-meetings-right-control">
      <div class="litmus-meetings-paging">
        <button [disabled]="!pagingButtons.isFirst || isMeetingListLoading" (click)="paginateFeedList('first')">
          <img src="assets/images/chevron-double-left.svg" />
        </button>
        <button [disabled]="!pagingButtons.isPrevious || isMeetingListLoading" (click)="paginateFeedList('previous')">
          <img src="assets/images/chevron-left.svg" />
        </button>
        <span [class.disabled]="pagingDetails.total <= 0"> {{pagingDetails.start}} - {{pagingDetails.end}}
          of {{pagingDetails.total}} </span>
        <button [disabled]="!pagingButtons.isNext || isMeetingListLoading" (click)="paginateFeedList('next')">
          <img src="assets/images/chevron-right.svg" />
        </button>
        <button [disabled]="!pagingButtons.isLast || isMeetingListLoading" (click)="paginateFeedList('last')">
          <img src="assets/images/chevron-double-right.svg" />
        </button>
      </div>
    </div>
  </div>
</div>

<div class="huddle-meeting-list-container" *ngIf="!isMeetingListLoading && isMeetingDataAvailable">
  <table class="huddle-meeting-table">
    <colgroup>
      <col *ngFor="let column of huddleTable.header;"
        [ngStyle]="{backgroundColor:((sortColumn == column.uniqueId || sortColumn == column.sortId))?'#3777ff14':'unset'}">
    </colgroup>
    <thead>
      <tr>
        <th *ngFor="let column of huddleTable.header;let colIdx = index;">
          <div class="header-wrapper"
            [ngStyle]="{justifyContent:(column.style && column.style.header)?column.style.header:''}">
            <div class="text-wrapper" *ngIf="!column.isHeaderTextHide"
              [ngStyle]="{color:(column && column.style && column.style.headerTextColor)?column.style.headerTextColor:''}"
              [ngClass]="{filter:(sortColumn == column.uniqueId)?true:false}">
              {{column.header}}</div>
            <div class="icon-wrapper" *ngIf="column?.image">
              <img [src]="column?.image" [alt]="column.header + ' icon'" />
            </div>
            <img *ngIf="column.isSortingEnabled == true" (click)="onSort(column)"
              [ngClass]="{'filter':  (sortColumn === column.uniqueId || sortColumn === column.sortId)? true : false}"
              class="sorting-icon" [src]="getSortIcon(column)" alt="sort icon">
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let row of huddleTable.rows let rowIdx = index;">
        <tr [class.expanded-row]="row.isExpanded">
          <td *ngFor="let column of huddleTable.header;let colIdx = index;">
            <div class="cell-wrapper" [ngClass]="{
              'sorting-enabled':column.isSortingEnabled == true,
              'clickable-cell':column.isClickable == true
          }" [ngStyle]="{
              justifyContent:(column.style && column.style.row)?column.style.row:''
          }">
              <div class="collapse-icon" [class.active]="row.isExpanded" *ngIf="colIdx == 0" (click)="onRowExpand(row)">
                <img class="drilldown-image" src="assets/images/chevron-right.svg">
              </div>
              <div class="text-wrapper" [class.clickable]="column.isClickable" (click)="onRowExpand(row)" [ngStyle]="{
                      whiteSpace:(column.textStyle && column.textStyle.whiteSpace)?column.textStyle.whiteSpace:'nowrap',
                      fontWeight: (column.textStyle && column.textStyle.fontWeight)?column.textStyle.fontWeight:'',
                      justifyContent:(colIdx == 0 && column.style && column.style.row)?column.style.row:''
                  }">
                <span class="display-text">
                  {{row[column.uniqueId]}}
                </span>
              </div>
            </div>

          </td>
        </tr>
        <tr *ngIf="row.isExpanded" class="huddle-meeting-detail-view">
          <td [id]="row['key']" *ngIf="row.isLoading" [attr.colspan]="huddleTable.header.length"
            class="child-table-loader">
            <div class="table-loader" [id]="'loader_'+row['key']">
              <app-ltms-loader class="loader-sm"></app-ltms-loader>
            </div>
          </td>
          <td *ngIf="!row.isLoading" [attr.colspan]="huddleTable.header.length"
            class="child-table-container huddle-meeting-detail-view">
            <ng-container *ngTemplateOutlet="meetingdetailstab; context: { $implicit: {} }"></ng-container>
          </td>
        </tr>
      </ng-container>

    </tbody>
  </table>
</div>
<div class="huddle-meeting-list-loader" *ngIf="isMeetingListLoading">
  <app-ltms-loader></app-ltms-loader>
</div>
<div lass="huddle-meeting-list-error" *ngIf="!isMeetingListLoading && !isMeetingDataAvailable">
  <app-ltms-error [code]="'404'"></app-ltms-error>
</div>

<ng-template #meetingdetailstab let-meetingdetails>
  <div class="huddle-meeting-details-container">
    <div class="huddle-meeting-details-tabs">
      <div class="huddle-meeting-details-tab" [class.active]="activeDetailTab == 'spotlights'"
        (click)="changeDetailTab('spotlights')">Spotlight</div>
      <div class="huddle-meeting-details-tab" [class.active]="activeDetailTab == 'actions'"
        (click)="changeDetailTab('actions')">Action plan</div>
      <div class="huddle-meeting-details-tab" [class.active]="activeDetailTab == 'escalations'"
        (click)="changeDetailTab('escalations')">Suggestion</div>
    </div>
    <div class="huddle-details-tab-contents">
      <div class="huddle-details-content huddle-spotlight-details" *ngIf="activeDetailTab == 'spotlights'">
        <ng-container
          *ngIf="!isDetailsLoading && rowDataForMeeting[activeDetailTab] && rowDataForMeeting[activeDetailTab].length">
          <div class="huddle-spotlight-card" *ngFor="let row of rowDataForMeeting[activeDetailTab]">
            <div class="huddle-spotlight-card-header">
              <div class="huddle-spotlight-card-chip">
                <img src="assets/images/trophy-outline.svg" alt="Trophy" />
              </div>
            </div>
            <div class="huddle-spotlight-card-body">
              <div class="huddle-spotlight-username" *ngIf="spotlightsMap && spotlightsMap.user_name">
                {{row[spotlightsMap.user_name]}}
              </div>
              <div class="huddle-spotlight-meetingname" *ngIf="spotlightsMap && spotlightsMap.header_id">
                {{row[spotlightsMap.header_id]}}
              </div>
              <div class="huddle-spotlight-card-text" *ngIf="spotlightsMap && spotlightsMap.content_id">
                <div class="ellipsed-text" [class.show-more]="row.showMore" [id]="'statement-'+row.key">
                  {{row[spotlightsMap.content_id]}}
                </div>
                <div class="show-more-btn-wrappar" *ngIf="isEllipsisActive(row)">
                  <button class="show-more-btn" (click)="changeCardView($event,row)">
                    {{(row.showMore)?'[Collapse]':'[More...]'}}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="isDetailsLoading">
          <div class="huddle-meeting-detail-loader">
            <app-ltms-loader></app-ltms-loader>
          </div>
        </ng-container>
        <ng-container
          *ngIf="!isDetailsLoading && !(rowDataForMeeting[activeDetailTab] && rowDataForMeeting[activeDetailTab].length)">
          <div class="error-info">
            <app-ltms-error [code]="'404'"></app-ltms-error>
          </div>
        </ng-container>

      </div>
      <div class="huddle-details-content huddle-action-details" *ngIf="activeDetailTab == 'actions'">
        <ng-container
          *ngIf="!isDetailsLoading && rowDataForMeeting[activeDetailTab] && rowDataForMeeting[activeDetailTab].length">
          <app-overview-table [config]="tableConfigs[activeDetailTab].configs"
            [columns]="tableConfigs[activeDetailTab].header" [fixedColumns]="tableConfigs[activeDetailTab].fixedHeader"
            [rows]="rowDataForMeeting[activeDetailTab]" (onEdit)="editMeetingDetail($event)"></app-overview-table>
        </ng-container>
        <ng-container *ngIf="isDetailsLoading">
          <div class="huddle-meeting-detail-loader">
            <app-ltms-loader></app-ltms-loader>
          </div>
        </ng-container>

        <ng-container
          *ngIf="!isDetailsLoading && !(rowDataForMeeting[activeDetailTab] && rowDataForMeeting[activeDetailTab].length)">
          <div class="error-info">
            <app-ltms-error [code]="'404'"></app-ltms-error>
          </div>
        </ng-container>
      </div>
      <div class="huddle-details-content huddle-suggestion-details" *ngIf="activeDetailTab == 'escalations'">
        <ng-container
          *ngIf="!isDetailsLoading && rowDataForMeeting[activeDetailTab] && rowDataForMeeting[activeDetailTab].length">
          <app-overview-table [config]="tableConfigs[activeDetailTab].configs"
            [columns]="tableConfigs[activeDetailTab].header" [fixedColumns]="tableConfigs[activeDetailTab].fixedHeader"
            [rows]="rowDataForMeeting[activeDetailTab]" (onEdit)="editMeetingDetail($event)"></app-overview-table>
        </ng-container>
        <ng-container *ngIf="isDetailsLoading">
          <div class="huddle-meeting-detail-loader">
            <app-ltms-loader></app-ltms-loader>
          </div>
        </ng-container>
        <ng-container
          *ngIf="!isDetailsLoading && !(rowDataForMeeting[activeDetailTab] && rowDataForMeeting[activeDetailTab].length)">
          <div class="error-info">
            <app-ltms-error [code]="'404'"></app-ltms-error>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>

<action-edit-modal *ngIf="showEditModal" (onClose)="closeEditModal()" (onCancel)="cancelEdit()"
  (onUpdate)="reloadList($event)" [configs]="modalData"></action-edit-modal>